import { render, staticRenderFns } from "./Brands.vue?vue&type=template&id=3ef347fd&"
import script from "./Brands.vue?vue&type=script&lang=js&"
export * from "./Brands.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports